import * as React from 'react';
import { useCartStorage } from '@grandvisionhq/lib-utils-cart';
import { ApplePayExpressCheckoutButtonContainer, GooglePayExpressCheckoutButtonContainer, PaypalExpressButton } from '@grandvisionhq/payments';

const ExpressActionContainer = ({ hasSubscription , isOrderInProgress , setIsOrderInProgress , onClickHandler  })=>{
    const [{ cartId , cartHash  }] = useCartStorage();
    if (!cartId) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "express-action__payment-methods"
    }, /*#__PURE__*/ React.createElement(ApplePayExpressCheckoutButtonContainer, {
        cartId: cartId,
        cartHash: cartHash,
        onClickHandler: onClickHandler
    }), /*#__PURE__*/ React.createElement(GooglePayExpressCheckoutButtonContainer, {
        cartId: cartId,
        cartHash: cartHash,
        onClickHandler: onClickHandler
    }), !hasSubscription && cartHash && /*#__PURE__*/ React.createElement(PaypalExpressButton, {
        setIsOrderInProgress: setIsOrderInProgress,
        cartId: cartId,
        cartHash: cartHash,
        isOrderInProgress: isOrderInProgress,
        onClickHandler: onClickHandler
    }));
};

export { ExpressActionContainer };
//# sourceMappingURL=ExpressActionContainer.js.map
